export default __webpack_public_path__ + "static/media/food.e638a926.jpg";